import { actionTypes } from './actions';

import initialState from './initialState';

export default function saveEmailReducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.START_REQUEST:
      return state.set('loading', true).set('error', null).set('data', null);
    case actionTypes.REQUEST_SUCCESS:
      // setting empty object because of empty server response
      return state.set('loading', false).set('data', action.payload || {});
    case actionTypes.REQUEST_FAILURE:
      return state.set('loading', false).set('error', action.payload);
    default:
      return state;
  }
}
